import React, { FC } from "react";
import { StatsCard } from "./StatsCard";
import { FolderWrapper } from "../FolderWrapper";
import { SECTION_IDS } from "../constants";
import { PrincipleSlider } from "./PrincipleSlider";
import { GallerySlider } from "./GallerySlider";

export const AboutUsSection: FC = () => (
  <FolderWrapper
    title="Про нас"
    titleClassName="!bg-green-base"
    className="flex flex-col gap-5 bg-green-gradient text-white-base py-8.25 xl:p-0 xl:gap-0"
    id={SECTION_IDS.ABOUT_US}
  >
    <div className="flex flex-col gap-5 items-center justify-center px-5 md:gap-8 xl:flex-row xl:px-0 xl:h-2/5">
      <div className="text-xs leading-normal xl:pl-[120px] xl:px-10 xl:py-12 xl:text-sm 4xl:px-16 4xl:text-xl 4xl:pl-[31.75]">
        <p>
          Консалтингова компанія «Універсальний бізнес ресурс» — надійний
          партнер у сфері бухгалтерського обліку, оподаткування, проєктного
          менеджменту та кадрового діловодства. Ми працюємо з ФОП, юридичними
          особами, ОСББ, неприбутковими організаціями та фізичними особами,
          надаючи допомогу з податками, деклараціями, зарплатами й фінансовими
          питаннями.
        </p>
        <br />
        <p>
          Також готуємо ґрантові заявки для бізнесу, громадських організацій і
          органів місцевого самоврядування. Працюємо з 2016 року, маємо понад 30
          років професійного досвіду та співпрацюємо з клієнтами по всій
          Україні.
        </p>
      </div>
      <StatsCard className="w-full h-full xl:min-w-150 4xl:min-w-183" />
    </div>

    <div className="px-5 pt-6 pb-5 xl:px-10 xl:pt-10 xl:pb-8">
      <PrincipleSlider />
    </div>

    <div className="px-5 pt-6 pb-8 xl:px-10 xl:pt-10 xl:pb-12">
      <GallerySlider />
    </div>
  </FolderWrapper>
);
